import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useActions, useForm, useFormState } from 'utils/hooks';
import * as listActions from 'store/lists/actions';
import * as visibilityActions from 'store/visibility/actions';
import Spinner from 'components/general/Spinner';
import Drawer, { DrawerHeader } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import config from './config';
import FormFooter from './FormFooter';
import TopPart from './TopPart';
import Select from 'common/components/form/inputs/Select';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';
import { Col, Row } from 'reactstrap';

const VisibilityForm = ({ active, drawer, isOpen, type, table }) => {
  const [loading, setLoading] = useState(true);

  const [disabled, setDisabled] = useState(false);

  const { formState, collectValues, loadValues } = useForm(config);
  const { fields, selectField } = useFormState(formState);
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const [getVisibility, updateVisibility] = useActions([
    visibilityActions.getVisibility,
    visibilityActions.updateVisibility
  ]);

  const organizations = useSelector(state => state.lists.organizations);

  useEffect(() => {
    if (!organizations?.options.length) {
      fetchListOptions('organizations');
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    if (isOpen) {
      const params = {
        id: active.id,
        type
      };

      getVisibility(params).then(response => {
        if (response) {
          loadValues({
            default: response.default,
            organizations: response.organizations.map(o => o.id)
          });
          setLoading(false);
        }
      });
    }
  }, [active.id, isOpen]);

  const submit = () => {
    const values = collectValues();

    if (!values) return;
    setDisabled(true);

    const params = {
      id: active.id,
      type,
      default: values.default,
      organization_ids: values?.organizations,
      table: table || undefined
    };

    updateVisibility(params).then(response => {
      if (response) {
        drawer.close();
      }
      setDisabled(false);
    });
  };

  return (
    <Drawer
      dontCloseOnClickOutside={loading}
      layout="table"
      {...drawer}
      className={`edit-visibility`}
    >
      <DrawerHeader className="cpt-12 cmt-4">
        <div>Visibility Settings</div>
        <div className="fw-bold text-violet">{active.name}</div>
      </DrawerHeader>
      {loading ? (
        <div className="h-100p w-100p d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      ) : (
        <FormDrawer>
          <div className="ps-8 pe-2 pt-3 visibility-list">
            <TopPart type={fields.default.value} selectField={selectField} />
            <Row noGutters>
              <Col xs={10}>
                <Select
                  options={organizations?.options}
                  className={`w-100p`}
                  classNamePrefix={`react-select`}
                  placeholder={'Search company'}
                  onChange={selectField('organizations')}
                  getOptionLabel={org => org.name}
                  getOptionValue={org => org.id}
                  isMulti
                  loadOptions={search => getAsyncOptions(search, 'organizations')}
                  defaultOptions={() => getInitialAsyncValues('organizations')}
                  {...fields?.organizations}
                />
              </Col>
            </Row>
          </div>
          <FormFooter disabled={disabled} submit={submit} drawer={drawer} />
        </FormDrawer>
      )}
    </Drawer>
  );
};

export default VisibilityForm;
